import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactGa from 'react-ga';
import { QtcRendererProvider } from '@3plearning/question-components-library';
import {
  acquireInitMleData,
  acquireQueryString,
  recordTime,
  TIMESTAMP_ENTER,
  queryString,
  registerDefaultAssign
} from './mle-actions';
import { setUserType } from '../user/user-actions';
import { MODULE_NAME_ACTIVITY, userTypes } from '../../helpers/constants';
import InternetConnectivity from '../internet-connectivity/internet-connectivity';
import ErrorHandling from '../error-handling/error-handling';
import Modal from '../modal/modal';
import Resources from '../../helpers/resources';
import { PageTitle } from '../page-title/page-title';
import MleContainer from './mle-container';

const Mle = () => {
  const dispatch = useDispatch();
  const { initMleReducer } = useSelector(state => state);
  const activityMetaData = (initMleReducer.find(item => item.meta.name === MODULE_NAME_ACTIVITY) || {}).meta;
  const { user: { schoolId } = {} } = activityMetaData || {};

  const [googleAnalyticsId, setGoogleAnalyticsId] = useState(false);

  const getGoogleAnalyticsId = async () => {
    try {
      const id = await Resources.env.substituteConfigurationItems('@GoogleTagManagerID');
      setGoogleAnalyticsId(id);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error acquiring Google Tag manager ID!');
    }
  };

  useEffect(() => {
    if (googleAnalyticsId) {
      ReactGa.initialize(googleAnalyticsId);
    }
  }, [googleAnalyticsId]);

  useEffect(() => {
    dispatch(setUserType(schoolId > 0 ? userTypes.SCHOOLSTUDENT : userTypes.HOMESTUDENT));
  }, [activityMetaData]);

  useEffect(() => {
    if (queryString().defaultAssignTeacherId) {
      dispatch(registerDefaultAssign({
        teacherUserProfileId: queryString().defaultAssignTeacherId,
        girlId: queryString().girlId
      }));
    }
    dispatch(acquireQueryString());
    dispatch(acquireInitMleData());
    dispatch(recordTime(TIMESTAMP_ENTER));
    getGoogleAnalyticsId();
  }, []);

  return (
    <Fragment>
      <PageTitle />
      <ErrorHandling />
      <Modal />
      <InternetConnectivity />
      <QtcRendererProvider>
        <MleContainer />
      </QtcRendererProvider>
    </Fragment>
  );
};

export default Mle;
